import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Panoramic%20overhead%20view%20of%20a%20beautifully%20curated%20fashion%20and%20lifestyle%20collection%20spread%20across%20a%20large%20oak%20dining%20table%2C%20mix%20of%20sneakers%2C%20knitwear%2C%20leather%20goods%2C%20fragrance%20bottles%2C%20and%20tech%20accessories%2C%20warm%20golden%20hour%20sunlight%20streaming%20through%20floor-to-ceiling%20windows%2C%20terracotta%20and%20sand%20tones%2C%20lived-in%20sophisticated%20home%20atmosphere%2C%20abundant%20natural%20textures%2C%20editorial%20interior%20photography%20with%20organic%20styling&width=1800&height=800&seq=cta-full-hipobuy-v2-2026&orientation=landscape"
          alt="Explore full Hipobuy Spreadsheet catalog"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/40 to-foreground-950/20"></div>
      </div>

      <div className="relative z-10 max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
          <div className="max-w-lg">
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
              Explore the<br />Full Catalog
            </h2>
            <p className="text-background-50/70 mt-4 text-base md:text-lg leading-relaxed max-w-md">
              Ready to discover more? Visit our main website for the complete collection of curated products, detailed comparison tables, and the latest spreadsheet updates.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-3 bg-background-50 text-foreground-950 px-8 py-4 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors"
            >
              Visit Kaspreadsheet
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-foreground-950 text-background-50">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </div>
            </a>
            <Link to="/hipobuy-spreadsheet-guide" className="inline-flex items-center justify-center gap-2 border border-background-50/30 text-background-50 px-8 py-4 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors">
              Read Our Guide
              <i className="ri-book-open-line w-5 h-5 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}